// @flow

import ko from 'rgs-knockout';
import { createJSableEntityListMapExtender, JSable } from 'jsable';
import type { ObservableArray } from 'rgs-knockout';

// tree
import TreeNodeModel from 'rgs-nfd-ui-kit/ko-components/tree/tree-node-model';

export type TTreeItemModel = JSable & {}

export type TTreeDataOptions = {
	itemViewModel: TTreeItemModel,
}

export default class TreeDataModel extends JSable {
	itemViewModel: TTreeItemModel;
	tree: ObservableArray<TreeNodeModel>;

	constructor (props: TTreeDataOptions) {
		super(props);

		this.itemViewModel = props.itemViewModel;
		this.tree = ko.observableArray([]).extend(createJSableEntityListMapExtender(
			TreeNodeModel,
			[
				this.itemViewModel,
			]
		));

		this.isEmpty = this._isEmpty.bind(this);
	}

	update (treeData: TreeNodeModel[]) {
		this.tree.fromJS(treeData);
	}

	_isEmpty () {
		return this.tree().length <= 0;
	}
}
